module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }]
  }, [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.addNoteClick()
      }
    }
  }, [_vm._v("Add Note")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "font-size": "1rem"
    },
    attrs: {
      "data": _vm.notesTable,
      "stripe": "",
      "cell-class-name": "cellStyle"
    },
    on: {
      "cell-click": _vm.noteEditClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": 15,
      "prop": "created",
      "label": "Date Created",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 25,
      "prop": "email",
      "label": "User Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": 70,
      "prop": "notes",
      "label": "Note"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "Note",
      "visible": _vm.noteDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.noteDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.noteDialog.loading),
      expression: "noteDialog.loading"
    }],
    attrs: {
      "model": _vm.noteDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "New Value",
      "type": "textarea",
      "autosize": ""
    },
    model: {
      value: (_vm.noteDialog.form.note),
      callback: function($$v) {
        _vm.$set(_vm.noteDialog.form, "note", $$v)
      },
      expression: "noteDialog.form.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.noteDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.NoteDialogHandler
    }
  }, [_vm._v("Save")]), _vm._v(" "), (!_vm.noteDialog.form.newNote) ? _c('el-button', {
    staticStyle: {
      "margin-top": "10px",
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.NoteDeleteHandler
    }
  }, [_vm._v("Delete Note")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67a11892"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Notes.vue
// module id = 1406
// module chunks = 1